const t={mobile:"100%",tablet:"100%",desktop:300},e={mobile:284,tablet:300,desktop:324};export{e as HEIGHT,t as WIDTH};
//# sourceMappingURL=constants.js.map
